const ArrowIcon = ({ viewBox = "0 0 12 12", className = "hayley-h-3 hayley-w-3 hayley-text-secondary", style = {} }) => {
  return (
    <svg data-testid="arrow-icon" viewBox={viewBox} fill="none" className={className} style={style}>
      <path d="M0.5 6H11.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.5 10L0.5 6L4.5 2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default ArrowIcon;
